import { ProgressBar } from "@/design-system/ProgressBar/ProgressBar";
import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";

type Props = {
  solvedCount: number;
  sbcsCount: number;
  /** Printed opposite the count, on the set card's own line: repeat + expiry. */
  meta?: React.ReactNode;
  className?: string;
};

/**
 * "n / m completed" over the filled track. Completed reads as plain foreground
 * rather than an accent — the bar being full already says it.
 */
export const SetProgress = ({
  solvedCount,
  sbcsCount,
  meta,
  className,
}: Props) => {
  const { t } = useTranslation("sbcs");
  const isCompleted = solvedCount > 0 && solvedCount === sbcsCount;

  return (
    <div className={cn("flex flex-col gap-y-2", className)}>
      <div className="flex items-baseline justify-between gap-x-2">
        <span
          className={cn(
            "text-xs font-semibold",
            isCompleted ? "text-foreground" : "text-foreground-faint",
          )}
        >
          {t("set.completedProgress", {
            solved: solvedCount,
            total: sbcsCount,
          })}
        </span>
        {meta}
      </div>
      {/* The Streamline default track is tuned for that screen's darker page;
          on a card surface it disappears, so it steps up one shade. */}
      <ProgressBar
        ratio={sbcsCount > 0 ? solvedCount / sbcsCount : 0}
        className="bg-control"
      />
    </div>
  );
};
